// UI strings for j's English anchor rung in Ääntämisvalmentaja (Axel 2026-10-12: "James", "jump";
// engine/src/rules/coach-english.ts): the rung's label, the English model buttons (native speakers' recordings
// from Wikimedia Commons, never Peterson), the note when a word has no model, and the sources page's section.
// The step's one-line instruction is in coachGuide (keyed by the step id j-feel-en, like every step).
import { defineArea } from '../area';

export const coachEnglishFi = {
  /** The rung's name in the rail and the ladder (instead of the kind's). */
  kind: 'Englanniksi',
  /** Beside the prompt: the words are English, not High Valyrian. */
  notHv: 'Englannin sanoja, ei valyriaa',
  /** The model buttons (the thumb zone's two Peterson buttons on this rung). */
  model: 'Malli',
  playSlow: (w: string) => `Englanninkielinen malli hitaasti (0,75×): ”${w}”`,
  playNormal: (w: string) => `Englanninkielinen malli (1×): ”${w}”`,
  /** The word chips: choose the word whose model the buttons play. */
  pick: 'Valitse sana, jonka mallin haluat kuulla',
  modelPlays: (w: string) => `Malli soi: ”${w}”.`,
  /** A word with no usable licensed recording. */
  noModel: (w: string) => `Sanasta ”${w}” ei ole mallia.`,
  credits: {
    title: 'Englannin sanojen mallit',
    text: 'Englannin sanojen mallit ovat syntyperäisten puhujien äänitteitä Wikimedia Commonsista. Niistä on leikattu hiljaisuus pois.',
    trimmed: 'muokattu: hiljaisuus leikattu',
  },
};

export const coachEnglishEn: typeof coachEnglishFi = {
  kind: 'In English',
  notHv: 'English words, not High Valyrian',
  model: 'Model',
  playSlow: (w) => `English model, slowly (0.75×): “${w}”`,
  playNormal: (w) => `English model (1×): “${w}”`,
  pick: 'Choose the word whose model you want to hear',
  modelPlays: (w) => `The model plays: “${w}”.`,
  noModel: (w) => `There is no model for “${w}”.`,
  credits: {
    title: 'Models of the English words',
    text: 'The models of the English words are native speakers’ pronunciation recordings from Wikimedia Commons, with the silence cut off.',
    trimmed: 'modified: silence trimmed',
  },
};

// Messages.coachEnglish (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('coachEnglish', coachEnglishFi, coachEnglishEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof coachEnglishFi> {}
}
